export default {
    props: {
        title: {
            type: String,
            default: ""
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/FilterSection/FilterSection.js